/*
 * サブシステム名：マスタ管理
 * 機能名：メニュー管理
 */

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import dolly from '@/rahmen/utils/dolly'

import modals from '@/ddv2.library/modals'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')

export default {
  name: 'MstMenuMaintenance',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdDataTable,
    DdEditDialog,
    DdIconButtonWithTooltip
  },
  data: () => ({
    modeKengen: 0,
    headers: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: 'メニューNO', value: 'menuCd', align: ' d-none' },
      { text: 'メニュータイトル', value: 'menuNm', sortable: false },
      { text: '表示順', value: 'hyojiOrder', align: 'right' },
      { text: '表示ステータス', value: 'description' },
      { text: '表示切替', value: 'dispSwitch', sortable: false },
      { text: '反映', value: 'actions', sortable: false },
      { text: '変更状況', value: 'memo' }
    ],
    rec: {},
    rows: [{}]
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      menuList: 'DDMasters/msysMenu'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        elem.description = elem.delFlg ? '非表示' : '表示中'
        elem.memo = elem.editFlg ? '変更中' : ''
        return elem
      }).sort((a, b) => {
        if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
        if (a.menuCd > b.menuCd) { return 1 }
        if (a.menuCd === b.menuCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
    this.fetchData()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rows
    },
    /**
     * 全件取得 ※初期表示時のみ
     * @returns
     */
    fetchData: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/MsysMenu/GetAll')
          .then((data) => {
            this.rows = data.payload
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
          })
      })
    },
    /**
     * 更新後の再取得 ※対象行のデータとClone情報を差し替える
     * @param {} recId
     * @param {*} rowIndex
     * @returns
     */
    getData: function (recId, rowIndex) {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/MsysMenu/find?id=${recId}`)
          .then((data) => {
            this.rec = data.payload
            // 取得データを差し替え
            this.rec.editFlg = false
            this.rec.memo = ''
            Object.assign(this.rows[rowIndex], this.rec)
            // CloneData更新
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            this.rows.splice()
          })
      })
    },
    initialize: function () {
      const opt = {
        loadMasters: ['msysmenu'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('■settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForRegister(opt)
    },
    onEditClose: function (e, row) {
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        this.rec = Object.assign({}, row.item)
        this.rec.hyojiOrder = row.value

        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.cloneRows[index].hyojiOrder !== this.rec.hyojiOrder || this.cloneRows[index].delFlg !== this.rec.delFlg) {
          this.rec.editFlg = true
        } else {
          this.rec.editFlg = false
        }

        Object.assign(this.rows[index], this.rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onSwitchDisplay: function (item) {
      // /* eslint no-debugger: "warn" */
      // debugger
      const index = this.rows.indexOf(item)
      this.rec = Object.assign({}, item)
      this.rec.delFlg = !this.rec.delFlg

      // 変更フラグ判定（≠Clone値は変更有とみなす）
      if (this.cloneRows[index].hyojiOrder !== this.rec.hyojiOrder || this.cloneRows[index].delFlg !== this.rec.delFlg) {
        this.rec.editFlg = true
      } else {
        this.rec.editFlg = false
      }

      Object.assign(this.rows[index], this.rec)
    },
    onCancel: function (item) {
      const index = this.rows.indexOf(item)
      this.rec = Object.assign({}, item)
      this.rec = this.cloneRows[index]
      this.rec.editFlg = false
      Object.assign(this.rows[index], this.rec)
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },
    onSave: function (item) {
      const p = modals.showConfirm
      p('COMQ0011').then((ok) => {
        if (ok === false || ok === undefined) { return }

        const index = this.rows.indexOf(item)
        this.rec = Object.assign({}, item)

        const self = this
        const opt = {
          registerRequestPromise: self.registerPromise,
          registerResponsePromise: (data) => {
            return new Promise(resolve => {
              // 更新後に自レコードのみ再取得
              this.getData(this.rec.id, index)
              resolve()
            })
          },
          getIdMethod: () => {
            return self.rec.id
          },
          continuousInputInitializePromise: (id) => {
            return new Promise(resolve => {
              resolve()
            })
          },
          getTransitionBackParams: function () {
            return {
              actionId: 0
            }
          },
          isUpdateModeMethod: function () {
            return true
          },
          isNoRefreshModeMethod: function () {
            return true
          },
          isNoMessageModeMethod: function () {
            return true
          },
          getSavedInputMethod: function () {
            return true
          }
        }
        this.register(opt)
      })
    },
    registerPromise: function () {
      // 登録/更新処理実行
      // 自レコードのみを更新する
      return this.HttpClient.put(`/api/v1/MsysMenu/Update?id=${this.rec.id}`, this.rec)
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    setRowColorClass: function (item) {
      return item.editFlg === true ? 'cellBackgroundColorGreen' : ''
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return 0 }
      if (inputValue === undefined) { return 0 }
      if (inputValue === '') { return 0 }
      return this.removeComma(inputValue)
    },
    removeComma: function (num) {
      if (!num) { return }

      if (window.isFinite(num) === true) {
        return num
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    }
  }
}
